import { render, staticRenderFns } from "./LoveMapDescription.vue?vue&type=template&id=15adbc39&scoped=true&"
import script from "./LoveMapDescription.vue?vue&type=script&lang=js&"
export * from "./LoveMapDescription.vue?vue&type=script&lang=js&"
import style0 from "./LoveMapDescription.vue?vue&type=style&index=0&id=15adbc39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15adbc39",
  null
  
)

export default component.exports